import React, { useState } from "react";
import CuDropdown from "../../common_component/component/CuDropdown";
import moment from "moment";
import { formatDate } from "../../_helper/utils/utils";

const options = [
  { key: 1, value: "days", text: "Days" },
  { key: 2, value: "weeks", text: "Week" },
  { key: 3, value: "months", text: "Month" },
];

const FollowUp = ({ nextVisit, setNextVisit }) => {
  const [numberOfDays, setNumberOfDays] = useState("");
  const [selectedOption, setSelectedOption] = useState("days");

  const handleOptionChange = (val) => {
    setSelectedOption(val);
    // setNextVisit(calculateDate(numberOfDays, val));
  };

  const calculateDate = (amount, unit) => {
    const currentDate = moment();
    return currentDate.add(amount, unit).format("DD-MM-YYYY");
  };

  const handleNumberOfDaysChange = (e) => {
    if (e.target.value > 0) {
      setNextVisit(calculateDate(e.target.value, selectedOption));
      setNumberOfDays(e.target.value);
    } else {
      setNextVisit("");
      setNumberOfDays("");
    }
  };

  //("NEXT VIST", nextVisit);
  return (
    <div className="mt-[90px]">
      <div className="w-full px-4 flex flex-col gap-4">
        <div className="w-full h-[50px] border rounded">
          <input
            className="w-full h-full outline-none pl-4 bg-[#F6F6F6]"
            placeholder="Number of Days"
            type="number"
            value={numberOfDays}
            onChange={handleNumberOfDaysChange}
          />
        </div>
        <div className="w-full">
          <CuDropdown
            options={options}
            value={selectedOption}
            onChange={handleOptionChange}
          />
        </div>
        <div>{nextVisit}</div>
      </div>
    </div>
  );
};

export default FollowUp;
